import { TERMS_LINKS } from '@avalara/bat-apps-shared/constants';

import { translate } from '@avalara/bat-apps-shared/i18n';
import ExternalLink from './external-link';
import { DisclaimerText } from './styled/components/cart';

type Props = {
  isDisabled: boolean;
  buttonLabel: string;
};

const CartDisclaimerText = ({ isDisabled, buttonLabel }: Props) => {
  if (isDisabled) {
    return null;
  }

  return (
    <DisclaimerText>
      <i>
        {translate('client.disclaimer.by-clicking-button-governed-by-terms', {
          buttonLabel,
          termsLink: (chunks) => (
            <ExternalLink href={TERMS_LINKS.general} alwaysOpenInNewTab>
              {chunks}
            </ExternalLink>
          ),
        })}
      </i>
    </DisclaimerText>
  );
};

export default CartDisclaimerText;
